globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.Controllers.Websites.CreationFormSubmissionController = (function(superClass)
{
    utils.extend(CreationFormSubmissionController, superClass);

    function CreationFormSubmissionController() {}

    CreationFormSubmissionController.prototype = {
        init: function()
        {
          appCustomerSpace.creationForm = new CreationForm;
        }
    }

    return CreationFormSubmissionController;
})(appCustomerSpace.Controllers.MainController);
